<div>
  <div>
    An S3 bucket already exists with name "{{ recoveryBucketName }}". Please configure a custom recovery bucket suffix
    for this bucket below, or configure an alternate
    <a href="{{ accountResourceConfigUrl }}">account-level default suffix</a>, then try again.
  </div>

  <form [formGroup]="configFormModel" (ngSubmit)="saveClick()" class="form-controls">
    <div class="flex-center-row control-header">
      <input
        type="text"
        formControlName="recoveryBucketSuffix"
        [placeholder]="defaultSuffix"
        class="arpio-input"
        minlength="2"
        maxlength="12"
      />
      <button type="submit" class="arpio-button margin-left" [disabled]="!validConfig">
        @switch (saveStatus) {
          @case ('saving') {
            <svg lucideLoaderCircle class="lucide-spin"></svg>
          }
          @case ('saved') {
            <svg lucideCheck></svg>
          }
          @default {
            Save
          }
        }
      </button>
    </div>
    <div class="new-bucket-name">
      <span class="new-bucket-name-label">New recovery bucket name:</span>
      <span class="new-bucket-name-value">{{ newRecoveryBucketName }}</span>
    </div>
  </form>
</div>
